import { INVENTORY_MODULE } from "@/api_framework/api_config";
import { IClinicToClinicWarehouseByCategoryIdResponse } from "@/api_framework/api_modals/Inventory";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setClinicWarehouseDetails } from "@/app_redux/reducers/slices/auth/inventory_slice";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";

AxiosCurlirize(axios, () => {});
export const useClinicWarehouseDetailsByCategoryIdAPI = () => {
  const dispatch = useAppDispatch();
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(
    async (category_ids?: any, cityId?: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

        await axios
          .post(
            `${INVENTORY_MODULE?.CLINIC_WAREHOUSE_DETAILS_BY_CATEGORY_ID?.baseURL}`,
            {
              city_id: cityId,
              category_ids: category_ids?.split(","),
            },
            {
              headers: {
                Authorization: `${accessToken}`,
                "Content-Type": "application/json",
              },
            },
          )
          .then((res: AxiosResponse<IClinicToClinicWarehouseByCategoryIdResponse>) => {
            if (res.data.status === true) {
              dispatch(setClinicWarehouseDetails({ data: res.data.data }));
            } else {
              dispatch(setClinicWarehouseDetails(null));
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            captureError(e);
          });
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return execute;
};
